import { addDays, differenceInCalendarDays, isEqual, startOfToday, subDays, subMonths } from 'date-fns';

import { feLifecycleStatusToProto } from '../shared/SkuEnumHelpers';

export const DATE_RANGE_PRESET = {
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS',
  LAST_6_MONTHS: 'LAST_6_MONTHS',
};

export const DATE_RANGE_PRESET_OPTIONS = [
  DATE_RANGE_PRESET.LAST_7_DAYS,
  DATE_RANGE_PRESET.LAST_30_DAYS,
  DATE_RANGE_PRESET.LAST_6_MONTHS,
];

export function earliestReportDate(today = startOfToday()) {
  return subMonths(today, 12);
}

// Reports cover closed days only
export function latestReportDate(today = startOfToday()) {
  return subDays(today, 1);
}

export function presetRange(preset, today = startOfToday()) {
  const to = latestReportDate(today);
  switch (preset) {
    case DATE_RANGE_PRESET.LAST_30_DAYS:
      return { from: subDays(to, 29), to };
    case DATE_RANGE_PRESET.LAST_6_MONTHS:
      return { from: subMonths(to, 6), to };
    case DATE_RANGE_PRESET.LAST_7_DAYS:
    default:
      return { from: subDays(to, 6), to };
  }
}

export function findMatchingPreset(range, today = startOfToday()) {
  return (
    DATE_RANGE_PRESET_OPTIONS.find(preset => {
      const candidate = presetRange(preset, today);
      return isEqual(candidate.from, range.from) && isEqual(candidate.to, range.to);
    }) || null
  );
}

export function shiftRange(range, direction, today = startOfToday()) {
  const lengthInDays = differenceInCalendarDays(range.to, range.from) + 1;
  const from = addDays(range.from, direction * lengthInDays);
  const to = addDays(range.to, direction * lengthInDays);
  if (from < earliestReportDate(today) || to > latestReportDate(today)) return range;
  return { from, to };
}

// One instant window in the user's timezone: local midnight to the day after
// the picked end, exclusive. The backend rejects an empty venue_ids, so callers skip
// the fetch for an empty selection instead of sending it.
export function toOrdersReportScope({ venueIds, range }) {
  return {
    venue_ids: venueIds,
    requested_pickup_time_range: {
      from_inclusive: range.from,
      to_exclusive: addDays(range.to, 1),
    },
  };
}

export function toOrdersReportFilter({ venueIds, range, lifecycleStatus }) {
  const lifecycleStatusProto = feLifecycleStatusToProto(lifecycleStatus);
  return {
    ...toOrdersReportScope({ venueIds, range }),
    ...(lifecycleStatusProto !== undefined ? { lifecycle_status: lifecycleStatusProto } : {}),
  };
}
